export const createAffiliateClickMutation = `
  mutation AffiliatesClickCreate(
    $referralCode: String
  ) {
    affiliatesClickCreate(input: {
      referralCode: $referralCode
    }) {
      clickId
    }
  }
`
